import React from 'react';
import './About.css';

const CancellationPolicy = () => {
  return (
    <div className="about-page">
      <div className="page-hero" style={{
        background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
      }}>
        <div className="container">
          <h1>Cancellation Policy</h1>
          <p>Please review our cancellation terms</p>
        </div>
      </div>

      <div className="container section">
        <div className="content-card">
          <p className="last-updated">Last Updated: October 15, 2025</p>

          <section className="policy-section">
            <h2>Cancellation Charges</h2>
            <p>Cancellation charges are based on the number of days before departure:</p>
            <table style={{width: '100%', borderCollapse: 'collapse', margin: '20px 0'}}>
              <thead>
                <tr style={{backgroundColor: '#f5f5f5'}}>
                  <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Days Before Departure</th>
                  <th style={{padding: '10px', border: '1px solid #ddd', textAlign: 'left'}}>Cancellation Charge</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>45+ days</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>10% of tour cost</td>
                </tr>
                <tr style={{backgroundColor: '#f9f9f9'}}>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>30-44 days</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>25% of tour cost</td>
                </tr>
                <tr>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>15-29 days</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>50% of tour cost</td>
                </tr>
                <tr style={{backgroundColor: '#f9f9f9'}}>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>7-14 days</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>75% of tour cost</td>
                </tr>
                <tr>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>Less than 7 days</td>
                  <td style={{padding: '10px', border: '1px solid #ddd'}}>100% of tour cost (No refund)</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section className="policy-section">
            <h2>How to Cancel</h2>
            <p>Email us at syedabuzar626@gmail.com or call +91 9731395805 with your booking reference number.</p>
          </section>

          <section className="policy-section">
            <h2>Refund Processing</h2>
            <p>Refunds are processed within 7-10 business days to the original payment method.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
